import React from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { RFI_EKYC_URL, RFI_URL } from '../../utils/constants';
import CommonButton from '../common-button/CommonButton';
import {
  ModalContainer,
  CloseWrapper,
  WarningImgContainer,
  MessageText,
  TitleContainer,
  TitleText,
  ExpiryContainer,
  ExpiryDateRow,
  ExpiryDateValue,
  ExpiryHintRow
} from './style';
import { BLUE_WARNING_ICON, CLOSE_NEW_ICON, CALENDAR_BLACK_OUTLINE_ICON, HAND_ICON } from '@Images';
import { AppDispatch } from '../../store.type';
import { activateLoader } from '@Redux/actions/ui-trigger';
import { isJumioApplicable } from '../../screens/ekyc-rfi';
import { getCountryCode } from '@Redux/selectors';
import { isJumioServiceAvailable } from '@Redux/actions/individual-user-flow/individual-user-flow-action';
import { findNearestDateEntry } from '@Redux/actions/rfi';
import { HelpCenterDeepLink } from '../deeplink-help-center/HelpCenterDeepLink';

type RFIModalProps = {
  onClose: (value: boolean) => void;
  navigate: any;
  rfiList: Record<string, any>[];
};

const RFIWarningModal = ({ onClose, navigate, rfiList }: RFIModalProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const countryCode = useSelector(getCountryCode);

  const nearestRfiExpiryEntry = findNearestDateEntry(rfiList, 'expiry_date');
  const rfiExpiryDate = nearestRfiExpiryEntry?.expiry_date
    ? moment(nearestRfiExpiryEntry.expiry_date).format('MMMM DD, YYYY')
    : null;

  const handleOnClick = async () => {
    let redirectURL = RFI_URL;
    /*
      If jumio applicable for KYC TYPE RFI and if there are other RFIs apart from KYC RFI,
      Check if isJumioServiceAvailable, if available push to EKYC RFI Route otherwise Normal RFI route.
      If there are no other rfis apart from KYC Type, push to EKYC RFI route irrespective of isJumioServiceAvailable status
      to show EKYC Down page.
    */
    if (isJumioApplicable(countryCode) && rfiList[0]?.document_code === 'KYC_TYPE') {
      dispatch(activateLoader());
      if (rfiList?.filter((rfi) => rfi?.document_code !== 'KYC_TYPE')?.length > 0) {
        const isJumioAvailable = await dispatch(isJumioServiceAvailable(countryCode, true));
        if (isJumioAvailable) redirectURL = RFI_EKYC_URL;
      } else redirectURL = RFI_EKYC_URL;
    }
    navigate(redirectURL);
    onClose(true);
  };

  return (
    <ModalContainer>
      <CloseWrapper>
        <img
          className="close-icon"
          src={CLOSE_NEW_ICON}
          alt="close"
          onClick={() => {
            onClose(true);
          }}
        />
      </CloseWrapper>
      <WarningImgContainer>
        <img src={BLUE_WARNING_ICON} alt="Warning" />
      </WarningImgContainer>
      <TitleContainer>
        <TitleText>Additional information required</TitleText>
      </TitleContainer>
      <MessageText id="pop_up_text">
        We just need a few more details from you to move things forward.
      </MessageText>
      {rfiExpiryDate && (
        <ExpiryContainer id="rfi_expiry_container">
          <ExpiryDateRow>
            Submit by <ExpiryDateValue>{rfiExpiryDate}</ExpiryDateValue>
            <img src={CALENDAR_BLACK_OUTLINE_ICON} alt="calendar" />
          </ExpiryDateRow>
          <ExpiryHintRow>
            <img src={HAND_ICON} alt="quick" />
            Takes just a moment to complete
          </ExpiryHintRow>
        </ExpiryContainer>
      )}
      <CommonButton
        text={rfiExpiryDate ? 'Submit now' : 'Continue'}
        className="proceed-btn"
        width={335}
        height={46}
        onClick={handleOnClick}
      />
      <div className="deeplink-container">
        <HelpCenterDeepLink cmsKey="rfiDocumentVerificationWeb" onClose={onClose} />
      </div>
    </ModalContainer>
  );
};

export default RFIWarningModal;
